var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7134_99147",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7134_99147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78627 17.6633C5.7066 17.5486 5.74606 17.4228 5.74606 17.3058C5.74234 16.314 5.73266 15.323 5.75053 14.3311C5.75648 14.0281 5.65373 13.9417 5.3678 13.9626C5.07219 13.9842 4.77286 13.973 4.47576 13.9663C3.68573 13.9492 3.16004 13.4972 2.99846 12.7183C2.48989 10.2656 1.97909 7.81211 1.46531 5.35937C1.27172 4.43531 1.86442 3.65348 2.80933 3.56264C4.4698 3.40255 6.12804 3.21937 7.78852 3.05481C9.63365 2.87164 11.481 2.70336 13.3262 2.52093C14.4326 2.41147 15.5399 2.29904 16.6441 2.1665C17.6211 2.04885 18.2689 2.38392 18.5161 3.16576C18.6345 3.53955 18.5377 3.90143 18.4639 4.26182C17.901 7.01985 17.3329 9.77638 16.7655 12.5337C16.5473 13.594 16.0812 13.9685 14.9851 13.9685C13.312 13.9685 11.6381 13.9752 9.965 13.9626C9.67014 13.9603 9.45867 14.037 9.24869 14.2515C8.19954 15.323 7.13326 16.3781 6.07071 17.4369C5.98731 17.5203 5.92477 17.6357 5.78627 17.664V17.6633Z",
    fill: "#25A5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13965 6.35693L15.9886 5.08887",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24902 10.4664L15.4032 9.28027",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24902 8.42845L15.608 7.16113",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.ac834c4fcb9594d82cbd1f183f93a448.svg";
export { ForwardRef as ReactComponent };